/* eslint-disable class-methods-use-this */
import { Pagination } from '@packages/toolbox/dist/declarations/pagination';
import { AxiosResponse } from 'axios';
import { http } from 'SharedDir/backend/axios/http';

import SimpleApi from 'SharedDir/backend/api/classes/simpleApi';
import ADMINISTRATION_SERVICE, {
  servicesUrl,
} from 'SharedDir/backend/endpoints/administration-service';
import { Status } from 'SharedDir/constants/approval';
import { CopyFormType } from 'SharedDir/declarations/copy';
import { NIssue } from 'SharedDir/declarations/issue';
import { Paginated, PaginationParams } from 'SharedDir/declarations/pagination';
import { NPublicServices } from 'SharedDir/declarations/public-service';
import { NServiceDesigner } from 'SharedDir/declarations/service-designer';
import { AnyObject, WithRelations } from 'SharedDir/declarations/shared';

import { paramsAllRequest } from '../default-params';

import ServiceBrief = NIssue.ServiceBrief;

type ServiceResponseCropped = Pagination.PaginationParamsOut<{
  data: NServiceDesigner.ServiceBaseShortList;
}>;

export default class AdministrationServiceApiClass extends SimpleApi<
  NServiceDesigner.Service,
  NServiceDesigner.ServiceBaseCreate,
  NServiceDesigner.Service
> {
  constructor() {
    super(servicesUrl);
  }

  /**
   * Получить записи мер поддержки в сокращенном виде
   *
   * @param paginationParams
   * @returns
   */
  public async getAllRecordsCropped(
    additionalParams: Record<string, string | number | boolean> = {}
  ): Promise<ServiceResponseCropped> {
    const { data }: AxiosResponse<ServiceResponseCropped> = await http({
      ...ADMINISTRATION_SERVICE.SERVICES.LIST_BRIEF,
      params: { ...paramsAllRequest, ...additionalParams },
    });

    return data;
  }

  /**
   * Опубликовать меру поддержки
   *
   * @param id
   * @returns
   */
  public async publish(id: number): Promise<NServiceDesigner.Service> {
    const responseData: NServiceDesigner.Service = await http({
      ...ADMINISTRATION_SERVICE.SERVICES.PUBLISH(id),
    })
      .then((r): NServiceDesigner.Service => r.data)
      .catch((e) => {
        throw e;
      });

    return responseData;
  }

  /**
   * Сменить статус
   *
   * @param id
   * @param status
   * @returns
   */
  public async changeStatus(id: number, status: Status): Promise<NServiceDesigner.Service> {
    const responseData: NServiceDesigner.Service = await http({
      ...ADMINISTRATION_SERVICE.SERVICES.CHANGE_STATUS(id),
      params: { status },
    })
      .then((r): NServiceDesigner.Service => r.data)
      .catch((e) => {
        throw e;
      });

    return responseData;
  }

  /**
   * Копировать маршрут услуги
   * @param id
   * @returns
   */
  public async copy(data: CopyFormType): Promise<NServiceDesigner.Service> {
    const endpoint = ADMINISTRATION_SERVICE.SERVICES.COPY(data.id);
    const responseData: any = await http({
      ...endpoint,
      data,
    })
      .then((r): NServiceDesigner.Service => r.data)
      .catch((e) => {
        throw e;
      });

    return responseData;
  }

  /**
   * Получаем все услуги, но с урезанным содержанием
   *
   * @param {T} params
   * @returns {Promise<Array<ServiceBrief>>}
   */
  async getBriefAll<T = AnyObject>(params?: T): Promise<Array<ServiceBrief>> {
    const {
      data: { data },
    } = (await http({
      ...ADMINISTRATION_SERVICE.SERVICES.LIST_BRIEF,
      params: {
        page: 1,
        rowsPerPage: null,
        sortBy: 'name',
        descending: false,
        ...params,
        isPublished: true,
      },
    })) as AxiosResponse<Paginated<ServiceBrief>, T>;
    return data;
  }

  async getGrouped(maxElements: number = 20): Promise<Array<NPublicServices.ShowCaseGroup>> {
    const {
      data: { elements: data },
    } = (await http({
      ...ADMINISTRATION_SERVICE.SERVICES.SHOWCASE_GROUPS,
      params: { maxElements },
    })) as AxiosResponse<NPublicServices.ShowCase<NPublicServices.ShowCaseGroup>>;
    return data;
  }

  async getMiddle(
    id: number,
    maxElements: number = 20
  ): Promise<NPublicServices.ShowCaseGroup | undefined> {
    return (await this.getGrouped(maxElements)).find((group) => group.id === id);
  }

  async updatePublished(
    id: number,
    data: Pick<NServiceDesigner.Service, 'showInPortalStatistics'>
  ) {
    const { data: service } = (await http({
      ...ADMINISTRATION_SERVICE.SERVICES.UPDATE_PUBLISHED(id),
      data,
    })) as AxiosResponse<NServiceDesigner.Service>;
    return service;
  }
}
